import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from 'services/api';
import type { Tenant, TenantPayload } from './useTenants';
import { TENANTS_QUERY_KEY } from './useTenants';

export const useCreateTenant = () => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tenant: TenantPayload) => {
      return (await api.post('/tenants', tenant)) as unknown as Tenant;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });
    },
  });
};
